export default __webpack_public_path__ + "static/media/29_desktop.dd682bca.jpg";